import API from 'services/TAPS_API';

export default function getCardDocumentTypes(filter) {
  return API.request(
    {
      method: 'GET',
      url: `/dictionary/kbk`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      params: {
        filter,
      },
    },
    true,
  ); //is cancelable
}
